import React, { useCallback, useState } from 'react';
import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import NavBar from '../Navbar/Navbar';
import TopBar from '../TopBar/TopBar';
import { ACTIVITY_LIBRARY_ROUTE, CHAT_ROUTE } from '../../utils/routes';

interface IProps {
  children: React.ReactNode;
  hideBreadCrumb?: boolean;
}
// page layout with topbar and navbar here Navbar and TopBar are scoped for coach
// height of topbar is 64px balance the height for the rest of the page
// TODO: add logic to show navbar and topbar based on user type
const CoachPageLayout = ({ children, hideBreadCrumb }: IProps) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isActivityLibrary = location.pathname === ACTIVITY_LIBRARY_ROUTE;
  const isChatRoute = location.pathname === CHAT_ROUTE;
  const isClientDetailsTab = searchParams.get('tab') === 'client-details';
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const [hidden, setHidden] = useState<boolean>(true);

  const handleBackGroundClick = () => {
    setHidden(true);
  };

  const getHeight = useCallback((): string => {
    if (isChatRoute) {
      return 'calc(100% - 88px)';
    }
    return isSmallScreen ? 'calc(100% - 9%)' : 'calc(100% - 14%)';
  }, [isChatRoute, isSmallScreen]);

  return (
    <Grid
      container
      display="flex"
      sx={{
        background: 'linear-gradient(163deg, #FFF 10.13%, #FFF4F0 89.18%)',
      }}
      minHeight="100vh"
      height={isActivityLibrary || isClientDetailsTab ? '100%' : '100vh'}
    >
      <Grid
        item
        xs={isSmallScreen ? 1.1 : 0.7}
        width={isSmallScreen ? '80px' : '84px'}
        sx={{
          background: 'linear-gradient(163deg, #FFF 10.13%, #FFF4F0 89.18%)',
        }}
      >
        <NavBar hidden={hidden} setHidden={setHidden} />
      </Grid>
      <Grid item xs={isSmallScreen ? 10.9 : 11.3} onClick={handleBackGroundClick}>
        <Box height="68px" display="flex" alignItems="center">
          <TopBar hideBreadCrumb={hideBreadCrumb} />
        </Box>
        <Box
          height={getHeight()}
          width="98%"
          borderRadius="10px"
          pl={isSmallScreen ? '30px' : '18px'}
          pr={isSmallScreen ? '20px' : '18px'}
          borderColor="secondary.dark"
          pb={isClientDetailsTab ? '36px' : ''}
        >
          {children}
        </Box>
      </Grid>
    </Grid>
  );
};

export default CoachPageLayout;
